import React from 'react';
import "../styles/PopularDishesSection.css";

// Import images
import lambChopsImage from "../assets/lambchops.jpg";
import chickenKebabImage from "../assets/chickenkebab.jpg";
import boneMarrowImage from "../assets/bonemarrow.jpg";
import chickenSouvlakiImage from "../assets/chickensouvlaki.jpg";

function PopularDishesSection() {
    const popularDishes = [
        {
            name: "Lamb Chops",
            description: "5 pieces of marinated lamb chops served with a side of salad.",
            price: "41.99",
            image: lambChopsImage,
        },
        {
            name: "Chicken Kebab & Fries",
            description: "Grilled chicken leg or breast served with crispy fries.",
            price: "26.99",
            image: chickenKebabImage,
        },
        {
            name: "Bone Marrow",
            description: "Seasoned soft tissue inside a bone served with garlic bread.",
            price: "20.99",
            image: boneMarrowImage,
        },
        {
            name: "Chicken Souvlaki",
            description: "Two skewers of chicken souvlaki with house salad and tzatziki sauce.",
            price: "21.99",
            image: chickenSouvlakiImage,
        },
    ];

    return (
        <section className="luxury-container">
            <div className="popular-dishes-section">
                <div className="luxury-header">
                    <h2 className="dishes-title">Our Most Famous Dishes</h2>
                    <p className="dishes-description">Experience our signature flavors crafted to perfection.</p>
                </div>
                <div className="dishes-container">
                    {popularDishes.map((dish, index) => (
                        <div key={index} className="dish-card">
                            <img src={dish.image} alt={dish.name} className="dish-image" />
                            <div className="dish-details">
                                <h3 className="dish-title">{dish.name}</h3>
                                <p className="dish-description">{dish.description}</p>
                                <p className="dish-price">${dish.price}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PopularDishesSection;
